// extracted by mini-css-extract-plugin
module.exports = {"container":"AddEditAdmin_container__7i1JI"};